export default "__VITE_ASSET__e781d5be__"